import { Link } from "react-router-dom";

export default function ServiceListCard({ item, type }) {
  return (
    <div
      className="group bg-white rounded-2xl
                 border border-gray-100
                 shadow-sm hover:shadow-xl
                 transition-all duration-300
                 h-[410px] flex flex-col overflow-hidden
                 hover:-translate-y-1"
    >
      <div className="h-[180px] bg-gray-100 overflow-hidden relative">
        <img
          src={item.img}
          alt={item.title}
          className="w-full h-full object-cover
                     transition-transform duration-300
                     group-hover:scale-105"
        />

        <div
          className="absolute inset-0 bg-black/0
                        group-hover:bg-black/5 transition"
        />
      </div>

      <div className="px-5 pt-4 pb-4 flex flex-col flex-grow">
        <h3
          className="text-[17px] font-semibold text-gray-900
                     leading-snug mb-1
                     line-clamp-2 min-h-[46px]"
        >
          {item.title}
        </h3>

        <p
          className="text-sm text-gray-600 leading-relaxed
                     line-clamp-3 min-h-[54px] mb-3"
        >
          {item.desc}
        </p>

        <Link
          to={`/${type}/${item.slug}`}
          className="inline-flex items-center justify-center
                     w-full py-2.5 rounded-lg
                     border border-blue-600
                     text-blue-600 font-semibold text-sm
                     transition-all duration-300
                     hover:bg-blue-600 hover:text-white
                     hover:shadow-sm"
        >
          View Details →
        </Link>
      </div>
    </div>
  );
}
